import { render, staticRenderFns } from "./lookImage2.vue?vue&type=template&id=2512bbe0&scoped=true&"
import script from "./lookImage2.vue?vue&type=script&lang=js&"
export * from "./lookImage2.vue?vue&type=script&lang=js&"
import style0 from "./lookImage2.vue?vue&type=style&index=0&id=2512bbe0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2512bbe0",
  null
  
)

export default component.exports